import React, { memo } from "react";

import { EMPTY_ICON } from "Utils";

import { VisualStyled, ImageStyled, StateStyled } from "./styles";

interface GeneralInfoProps {
  link: string | undefined;
  name: string;
  // state: string;
  missionId: string | undefined;
  missionPlan: Mission | undefined;
  isLoading?: boolean;
}

export const GeneralInfo = memo(
  ({ link, name, missionId, missionPlan, isLoading }: GeneralInfoProps) => {
    return (
      <>
        <VisualStyled>
          <ImageStyled src={link ?? EMPTY_ICON} />
          <div>{name}</div>
        </VisualStyled>
        <StateStyled>
          <div>
            {isLoading
              ? "Loading..."
              : missionPlan?.name
              ? missionPlan.name
              : missionId
              ? "Go to staging"
              : "Ready for work"}
          </div>
          {/* TODO: Add the feature when API is ready
          <ActionButton
            isCancel={true}
            onClick={() => {
              return;
            }}
          >
            End Mission
          </ActionButton>
        */}
        </StateStyled>
      </>
    );
  }
);
